export const truncate = (text: string, length: number) =>
  text.length > length ? text.substring(0, length) + "..." : text

export const dateFromWp = (dateStr: string) =>
  `Publicerad ${new Date(dateStr).toLocaleDateString("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })}`
